import { render, staticRenderFns } from "./MembresiasView.vue?vue&type=template&id=daa5281e&scoped=true"
import script from "./MembresiasView.vue?vue&type=script&lang=js"
export * from "./MembresiasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa5281e",
  null
  
)

export default component.exports